/*
 * FILE: unified_ui/src/stores/toast.ts
 * PURPOSE: Transient in-app notification (success / info / error).
 *          One global toast slot, auto-dismisses after a configurable
 *          duration. Subsequent `show()` calls replace the message
 *          and reset the timer (so rapid-fire "Скопировано!" feedback
 *          stays visible for the full window).
 * OWNS: toast message + dismiss timer.
 * EXPORTS: useToastStore — message, show(text, durationMs?), dismiss()
 * DOCS: docs/architecture/components/core.md
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
  const message = ref<string | null>(null)
  let timer: ReturnType<typeof setTimeout> | null = null

  function show(text: string, durationMs = 2500) {
    if (timer) clearTimeout(timer)
    message.value = text
    timer = setTimeout(() => {
      message.value = null
      timer = null
    }, durationMs)
  }

  function dismiss() {
    if (timer) clearTimeout(timer)
    message.value = null
    timer = null
  }

  return { message, show, dismiss }
})
